import { baseApi } from '@krp/client-runtime'

import type { AboutReport } from '../model/types'
import { decodeAbout } from './contracts'
import { PLATFORM_ABOUT_URLS } from './urls'

export const aboutApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Версии служб — без повтора: окно открывают, чтобы узнать, что работает СЕЙЧАС; повтор спрятал бы
     * недоступность, которую оно и показывает. Кэш держит шлюз (30 с), а не клиент. `fresh` — кнопка «Обновить».
     */
    platformAbout: build.query<AboutReport, { fresh: boolean }>({
      query: (arg) => ({
        url: arg.fresh ? PLATFORM_ABOUT_URLS.aboutFresh : PLATFORM_ABOUT_URLS.about,
        decode: decodeAbout,
        noRetry: true,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
})

export const { platformAbout } = aboutApi.endpoints
